import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import imageDefaultBase64 from '../../livesHrComponentes/helpers/imageDefaultBase64.js'

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnChanges {
  @Input() base64Image: string;
  @Input() base64Stamp: string;
  @Input() base64customImage: string;
  @Input() type: string;
  imageData: string;
  stampData: string;
  customImage: string;
  imageDefault: string = 'data:image/png;base64,' + imageDefaultBase64;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.base64Image) {
      this.setImageData();
    }

    if (changes.base64Stamp) {
      this.setStampData();
    }

    if (changes.base64customImage) {
      this.setCustomImage();
    }
  }

  private setImageData() {
    if (this.base64Image) {
      this.imageData = this.base64Image;
    } else {
      this.imageData = null;
    }
  }

  private setStampData() {
    if (this.base64Stamp) {
      this.stampData = this.base64Stamp;
    } else {
      this.stampData = null;
    }
  }

  private setCustomImage() {
    if (this.base64customImage) {
      this.customImage = 'data:image/png;base64,' + this.base64customImage;
    } else {
      this.customImage = null;
    }
  }
}
